import { Guard } from './guard';
import { useContext } from 'react';
import { UserContext } from '../user/User.context';

export default function SupplierAdminGuard(): Guard {
  const userContext = useContext(UserContext);
  const { user } = userContext;

  return {
    canActivate: () => {
      return (
        !!user &&
        !!user.roles &&
        !!user.roles.find(r => r.name === 'SupplierAdmin')
      );
    }
  };
}
